export default __webpack_public_path__ + "static/media/ALA.faa0b972.svg";